export function addColumnsGroupHeader(header, columns){
    return [
        {
            Header: header,
            columns: columns
        }
    ]
}